<template>
  <l-marker
    v-show="haveGeoloc"
    :lat-lng="userPosition"
    :icon="getUserIconPosition(color1, color2)"
  />
</template>

<script>
import { LMarker } from 'vue2-leaflet'
import { divIcon } from 'leaflet'
export default {
  name: 'IconUserPosition',
  props: {
    haveGeoloc: Boolean,
    userPosition: Array,
    color1: String,
    color2: String
  },
  components: {
    LMarker
  },
  methods: {
    getUserIconPosition(color1, color2) {
      return divIcon({
        className: `markerTootip`,
        iconSize: [25, 80],
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 41">
    <style>
      .user-pin-color-1 {
        fill: ${color1};
      }

      .user-pin-color-2 {
        fill: ${color2};
      }
    </style>
  <g>
    <ellipse class="user-pin-color-1" cx="12.5" cy="13.32" rx="9.79" ry="10.05"/>
    <path class="user-pin-color-2" d="M25,12.63C25,6.11,19.4.82,12.5.82S0,6.11,0,12.63C0,26.53,12.5,41,12.5,41S25,26.53,25,12.63ZM12.5,3.27a9.92,9.92,0,0,1,9.79,10.05A9.92,9.92,0,0,1,12.5,23.37a9.92,9.92,0,0,1-9.79-10A9.92,9.92,0,0,1,12.5,3.27Z"/>
    <path class="user-pin-color-2" d="M16.81,10.84h-3.5v-.7a2.16,2.16,0,1,0-1.62,0v.7H8.19a.54.54,0,0,0,0,1.08h2.69v3.77L9.6,19.53a.77.77,0,0,0,.73,1h0a.77.77,0,0,0,.73-.53l1.44-4.32L13.94,20a.77.77,0,0,0,.73.53h0a.77.77,0,0,0,.73-1l-1.28-3.84V11.92h2.69a.54.54,0,0,0,0-1.08Z"/>
  </g>
</svg>`
      })
    }
  }
}
</script>
